import { timeout } from 'widgets/toolbox/util';
import { setCookie, getCookie } from 'widgets/toolbox/cookie';
import { RefElement } from 'widgets/toolbox/RefElement';
import { submitFormJson } from 'widgets/toolbox/ajax';

/**
 * @description SwitchCountryPopup implementation
 * @param Modal Base widget for extending
 * @returns SwitchCountryPopup class
 */
export default function (Modal: ReturnType<typeof import('widgets/global/Modal').default>) {
    /**
     * @category widgets
     * @subcategory header
     * @class SwitchCountryPopup
     * @augments Modal
     * @classdesc SwitchCountryPopup widget, that contains all needed logic to display switch country component.
     */
    class SwitchCountryPopup extends Modal {
        longWaitingTimeout: ReturnType<typeof timeout>|undefined;

        /**
         * @description Returns Widget configuration object
         */
        prefs() {
            return {
                actionUrl: '',
                classesActivated: 'm-activated',
                ...super.prefs()
            };
        }

        /**
         * @description Get  fields object action and querystring
         */
        getFormFields() {
            const container = document.createElement('div');
            const fields = <Record<string, string|number|boolean>> {};

            container.innerHTML = String(this.ref('html').data('querystring'));
            fields.action = String(this.ref('html').data('action'));
            fields.queryString = container.innerText;

            return fields;
        }

        correctCountry(button: RefElement) {
            if (button) {
                setCookie('hide_changelocale', '1', 30, true); // expires: days
                const url = String(button.data('url'));
                let fields = {};

                fields = this.getFormFields();

                return submitFormJson(
                    url,
                    fields,
                    'POST'
                )
                    .then((response) => {
                        if (response && response.redirectUrl) {
                            window.location.assign(<string>response.redirectUrl);
                        }

                        return response;
                    });
            }

            return Promise.resolve(null);
        }

        /**
         * @description Widget initialization logic
         * @listens "switchCountryPopup.show"
         */
        init(): void {
            super.init();

            if (!getCookie('hide_changelocale')) {
                this.showSwitchCountryPopup();
            }
        }

        /**
         * @description A method, called when event `click` happens on country select icon
         * - Shows countrySelector panel
         * - Update content of the panel
         */
        showSwitchCountryPopup(): void {
            // @ts-expect-error ts-migrate(2554) FIXME: Expected 1-2 arguments, but got 0.
            this.showModal();
        }

        /**
         * @description Close country select Dialog
         * @listens dom#click
         */
        cancel(): void {
            setCookie('hide_changelocale', '1', 30, true); // expires: days
            super.cancel();
        }

        /**
         * @description Fires `alert.show` event to be handled with Global Alerting System
         * @param accessibilityAlert - Alert string
         */
        accessibilityAlert(accessibilityAlert: string): void {
            this.eventBus().emit('alert.show', {
                accessibilityAlert
            });
        }
    }

    return SwitchCountryPopup;
}
